module.exports = __webpack_public_path__ + "icon_close_outline-c2e22f01bf896eceae2bf7338295e0be.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/icon_close_outline.svg
// module id = 1020
// module chunks = 0 3 6